export interface CompanyFilterType {
  selectedCompanies: server.dto.CompanySmall[]
}

export const getSortedCompanies = (filter: CompanyFilterType) => {
  return filter.selectedCompanies.map(a => a.name)
    .sort((a, b) => a.localeCompare(b));
};

export const initialCompanyFilter: CompanyFilterType = {
  selectedCompanies: []
};
